import { Button, ListItemButton, ListItemText } from "@mui/material";
import moment from "moment";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import checkAccess from "../../../../shared/checkAccess";
import CustomModal from "../../../../shared/CustomModal";
import CustomTable from "../../../../shared/CustomTable";
import notificationError from "../../../../shared/notificationError";
import notificationSuccess from "../../../../shared/notificationSuccess";
import { RootState } from "../../../../store";
import { approveRemoveTargetHead, approveRemoveTargetHr, deleteRemoveTarget } from "../removeTarget.api";
import { setTimeGetData } from "../removeTarget.reducer";
import RemoveTargetApprovalHead from "./RemoveTargetApprovalHead";
import RemoveTargetEdit from "./RemoveTargetEdit";

export default function RemoveTargetAll() {

    const dispatch = useDispatch()

    const { timeGetData } = useSelector((state: RootState) => state.removeTarget)

    const [dataSelected, setDataSelected] = useState<any>({})
    const [modalEdit, setModalEdit] = useState(false)
    const [modalApprovalHead, setModalApprovalHead] = useState(false)

    const handleCloseModalEdit = (isReload: boolean) => {
        setModalEdit(false)
        if (isReload) {
            dispatch(setTimeGetData(new Date().getTime()))
        }
    }

    const handleCloseModalApprovalHead = (isReload: boolean) => {
        setModalApprovalHead(false)
        if (isReload) {
            dispatch(setTimeGetData(new Date().getTime()))
        }
    }

    const handleDelete = (id: string) => {
        Swal.fire({
            icon: "question",
            title: "Are you sure to delete this data?",
            showCancelButton: true
        })
            .then(response => {
                if (response.isConfirmed) {
                    dispatch<any>(deleteRemoveTarget(id))
                        .unwrap()
                        .then((response: any) => {
                            if (response.status === 200) {
                                notificationSuccess("success delete removeTarget")
                                dispatch(setTimeGetData(new Date().getTime()))
                            }
                            else {
                                notificationError(response)
                            }
                        })
                }
            })
    }

    const handleApproveHeadMultiple = (dataIdSelected: any) => {
        if (dataIdSelected.length > 0) {
            dispatch<any>(approveRemoveTargetHead({
                ids: dataIdSelected
            }))
                .unwrap()
                .then((response: any) => {
                    if (response.status === 200) {
                        notificationSuccess("removeTarget successfully approved")
                        dispatch(setTimeGetData(new Date().getTime()))
                    }
                    else {
                        notificationError(response)
                    }
                })
        }
        else {
            Swal.fire({
                title: "Select at least one row",
                icon: "error"
            })
        }
    }

    const handleApproveHrMultiple = (dataIdSelected: any) => {
        if (dataIdSelected.length > 0) {
            dispatch<any>(approveRemoveTargetHr({
                ids: dataIdSelected
            }))
                .unwrap()
                .then((response: any) => {
                    if (response.status === 200) {
                        notificationSuccess("removeTarget successfully approved")
                        dispatch(setTimeGetData(new Date().getTime()))
                    }
                    else {
                        notificationError(response)
                    }
                })
        }
        else {
            Swal.fire({
                title: "Select at least one row",
                icon: "error"
            })
        }
    }

    return (
        <Fragment>
            <CustomModal
                open={modalEdit}
                onClose={handleCloseModalEdit}
                title="Edit RemoveTarget"
                component={
                    <RemoveTargetEdit onClose={handleCloseModalEdit} data={dataSelected} />
                }
            />
            <CustomModal
                open={modalApprovalHead}
                onClose={handleCloseModalApprovalHead}
                title="Head Approval"
                component={
                    <RemoveTargetApprovalHead onClose={handleCloseModalApprovalHead} data={dataSelected} />
                }
            />
            <CustomTable
                url={"/removetarget"}
                filterDate={true}
                columns={[
                    {
                        name: "Employee",
                        key: "employee_name"
                    },
                    {
                        name: "Remove Target Date",
                        key: "name",
                        customRender: (props: any) => {
                            return (
                                <td>
                                    <span>
                                        {props.data.name ? moment(props.data.name).format('DD-MM-YYYY') : '-'}
                                    </span>
                                </td>
                            )
                        }
                    },
                    {
                        name: "Remove Target",
                        key: "value"
                    },
                    {
                        name: "Notes",
                        key: "notes"
                    },
                    {
                        name: "Status",
                        key: "status_name"
                    },
                    {
                        name: "Rejection Notes",
                        key: "notes_approval"
                    },
                    {
                        name: "Jobnumber",
                        key: "jobnumber_number_job"
                    },
                    {
                        name: "KOJ",
                        key: "koj_name"
                    },
                    {
                        name: "Quantity Pole",
                        key: "quantity_pole"
                    }
                ]}
                headerActions={(props: any) => (
                    <Fragment>
                        {checkAccess("APPROVAL_HEAD") &&
                            <Button
                                variant="contained"
                                onClick={() => handleApproveHeadMultiple(props.dataIdSelected)}
                            >
                                Approve Head
                            </Button>
                        }
                    </Fragment>
                )}
                rowActions={(props: any) => (
                    <Fragment>
                        {checkAccess("EDIT") &&
                            <ListItemButton onClick={() => { setDataSelected(props.data); setModalEdit(true) }}>
                                <ListItemText>Edit</ListItemText>
                            </ListItemButton>
                        }
                        {checkAccess("DELETE") &&
                            <ListItemButton onClick={() => handleDelete(props.data.id)}>
                                <ListItemText>Delete</ListItemText>
                            </ListItemButton>
                        }
                    </Fragment>
                )}
                rowActionsAdditional={(props: any) => {
                    return (
                        <Fragment>
                            {checkAccess("APPROVAL_HEAD") && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={e => {
                                        setDataSelected(props.data)
                                        setModalApprovalHead(true)
                                    }}>
                                    Head Approval
                                </Button>
                            )}
                        </Fragment>
                    )
                }}
                timeGetData={timeGetData}
                selectRow={checkAccess("APPROVAL_HEAD") || checkAccess("APPROVAL_HR")}
            />
        </Fragment>
    )
}